/* eslint-disable */
import { HintsType } from '../ContactSearchPanelEnum';
export default {
  [HintsType.thirdPartyNoRecordsContent]:
    'Introduza, pelo menos, {minimumLength} carateres ou dígitos para pesquisar todos os registos {sourceName}.',
  [HintsType.noFilterOrSearchRecordsTitle]: 'Não foram encontrados resultados',
  [HintsType.noFilterOrSearchRecordsContent]:
    'Verifique os resultados de outras origens ou altere a palavra-chave.',
  [HintsType.searching]: 'A pesquisar…',
  companyTabTitle: 'Empresa',
  personalTabTitle: 'Pessoal',
  direct: 'Direto',
  extension: 'Ext.',
  contact: 'Contacto',
  mobile: 'Telemóvel',
  company: 'Empresa',
  home: 'Casa',
  home2: 'Casa',
  other: 'Outros',
  business: 'Profissional',
  business2: 'Profissional',
  car: 'Carro',
  fax: 'Fax',
  assistant: 'Assistente',
  callback: 'Chamada de retorno',
  MobileNumber: 'Número de telemóvel',
  ContactNumber: 'Número de contacto',
  DirectNumber: 'Número direto',
  doNotCall: 'Não ligar',
} as const;

// @key: @#@"[HintsType.thirdPartyNoRecordsContent]"@#@ @source: @#@"Enter at least {minimumLength} characters or digits to search all {sourceName} records."@#@
// @key: @#@"[HintsType.noFilterOrSearchRecordsTitle]"@#@ @source: @#@"No results found"@#@
// @key: @#@"[HintsType.noFilterOrSearchRecordsContent]"@#@ @source: @#@"Check results from other sources or change your keyword."@#@
// @key: @#@"[HintsType.searching]"@#@ @source: @#@"Searching..."@#@
// @key: @#@"companyTabTitle"@#@ @source: @#@"Company"@#@
// @key: @#@"personalTabTitle"@#@ @source: @#@"Personal"@#@
// @key: @#@"direct"@#@ @source: @#@"Direct"@#@
// @key: @#@"extension"@#@ @source: @#@"Ext"@#@
// @key: @#@"contact"@#@ @source: @#@"Contact"@#@
// @key: @#@"mobile"@#@ @source: @#@"Mobile"@#@
// @key: @#@"company"@#@ @source: @#@"Company"@#@
// @key: @#@"home"@#@ @source: @#@"Home"@#@
// @key: @#@"home2"@#@ @source: @#@"Home"@#@
// @key: @#@"other"@#@ @source: @#@"Other"@#@
// @key: @#@"business"@#@ @source: @#@"Business"@#@
// @key: @#@"business2"@#@ @source: @#@"Business"@#@
// @key: @#@"car"@#@ @source: @#@"Car"@#@
// @key: @#@"fax"@#@ @source: @#@"Fax"@#@
// @key: @#@"assistant"@#@ @source: @#@"Assistant"@#@
// @key: @#@"callback"@#@ @source: @#@"Callback"@#@
// @key: @#@"MobileNumber"@#@ @source: @#@"Mobile Number"@#@
// @key: @#@"ContactNumber"@#@ @source: @#@"Contact Number"@#@
// @key: @#@"DirectNumber"@#@ @source: @#@"Direct Number"@#@
// @key: @#@"doNotCall"@#@ @source: @#@"Do Not Call"@#@
